<template>
  <div>
    <div class="contentArea">
      <AgGrid />
    </div>
  </div>
</template>

<script>
import AgGrid from "./elements/ag-grid-table/AgGridTable";

import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid,
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug" }),
  },

  mounted() {
    this.$store.commit("general/GET_TAB", this.nowSlug);
    this.$store.dispatch("general/getTable", this.nowSlug);
  },
};
</script>
